<template>
	<div class="ContentSpreadsheet">
		<Head :hasBack="true" @back="goBack">
			<div class="heading">
				<h1>Spreadsheet</h1>
			</div>
			<div class="actions">
				<ActionButton class="save" :disabled="!canSave" @click="save">Save</ActionButton>
			</div>
		</Head>
		<div class="body">
			<SpreadsheetView ref="view" :filter="filter" @can-save-change="canSave = $event" />
		</div>
	</div>
</template>

<script>
// Route shell for the spreadsheet editor. Mirrors how Content.vue is wired: it receives the
// shared context (me/space/locales/...) via ProviderMixin and provides it down, reads the
// filter that Content transferred through the route query, and hands it to SpreadsheetView.
// All actual grid logic lives in the spreadsheet components, not here.
import Head from './Head.vue'
import ProviderMixin from './ProviderMixin.js'
import ActionButton from '../components/ActionButton.vue'
import SpreadsheetView from '../components/spreadsheet/SpreadsheetView.vue'
import { filterFromQuery } from '../components/fields/FilterUtil'

export default {
	name: 'ContentSpreadsheet',
	components: { Head, ActionButton, SpreadsheetView },
	mixins: [ ProviderMixin ],
	inject: [ 'base', 'endpoint', 'spaceId', 'environment', 'permissions' ],
	data: () => ({
		// mirrors SpreadsheetView.canSave so the header Save button reflects it
		canSave: false,
	}),
	computed: {
		// the filter is carried over from Content.vue via the route query, parsed with the
		// exact same logic the entry list uses so the two views stay in sync
		filter() {
			return filterFromQuery(this.$route.query)
		},
	},
	methods: {
		goBack() {
			this.$router.push({ path: this.base + '/entries', query: this.$route.query })
		},
		// returns the promise so ActionButton shows its spinner until the save completes
		save() {
			return this.$refs.view.save()
		},
	},
	created() {
		document.title = 'Spreadsheet'
	},
}
</script>

<style scoped>
.heading { flex: 1; }
.actions { display: flex; gap: 8px; align-items: center; }
.body { margin: 20px; }
</style>
